import { createFileRoute } from "@tanstack/react-router";

import TabSwitcher from "../../../components/wallets/WithdrawTabSwitcher";
import { WithdrawalType } from "../../../constants";
import InternationalWithdrawalForm from "../../../components/wallets/WithdrawalForms/InternationalWithdrawalForm";
import LocalWithdrawalForm from "../../../components/wallets/WithdrawalForms/LocalWithdrawalForm";
import { useTransaction } from "../../../contexts/TransactionContext";
import { requireRouteAccess } from "../../../utils/authorization";

export const Route = createFileRoute("/_app/send/")({
  beforeLoad: () => requireRouteAccess("/send"),
  component: Send,
});

function Send() {
  const { state, updateTransaction } = useTransaction();

  const handleWithdrawalTypeChange = (type: WithdrawalType) => {
    updateTransaction({ withdrawalType: type });
  };

  return (
    <div className="lg:w-1/2 w-full mx-auto bg-white p-3 rounded-lg">
      <TabSwitcher
        withdrawalType={state.withdrawalType}
        handleWithdrawalTypeChange={handleWithdrawalTypeChange}
      />

      {state.withdrawalType === WithdrawalType.INTERNATIONAL && (
        <InternationalWithdrawalForm />
      )}

      {state.withdrawalType === WithdrawalType.LOCAL && <LocalWithdrawalForm />}
    </div>
  );
}
